import { useState, useRef, useEffect } from 'react';
import { Download, FileText, FileSpreadsheet, ChevronDown, Loader2 } from 'lucide-react';

interface ExportDropdownProps {
  onExportCSV: () => void;
  onExportPDF: () => void;
  loading?: boolean;
}

export function ExportDropdown({ onExportCSV, onExportPDF, loading }: ExportDropdownProps) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    if (open) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [open]);

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        disabled={loading}
        className="inline-flex items-center gap-2 rounded-lg border border-border bg-card px-3 py-2 text-sm font-medium text-foreground transition-colors hover:bg-muted disabled:opacity-50"
      >
        {loading ? (
          <Loader2 size={16} className="animate-spin" />
        ) : (
          <Download size={16} />
        )}
        Exportar
        <ChevronDown size={14} className={`transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>

      {open && (
        <div className="absolute right-0 z-50 mt-1 w-44 rounded-lg border border-border bg-card shadow-lg">
          <button
            type="button"
            onClick={() => {
              setOpen(false);
              onExportCSV();
            }}
            className="flex w-full items-center gap-2 px-3 py-2.5 text-sm text-foreground transition-colors hover:bg-muted rounded-t-lg"
          >
            <FileSpreadsheet size={16} className="text-green-600 dark:text-green-400" />
            Exportar CSV
          </button>
          <button
            type="button"
            onClick={() => {
              setOpen(false);
              onExportPDF();
            }}
            className="flex w-full items-center gap-2 px-3 py-2.5 text-sm text-foreground transition-colors hover:bg-muted rounded-b-lg"
          >
            <FileText size={16} className="text-red-600 dark:text-red-400" />
            Exportar PDF
          </button>
        </div>
      )}
    </div>
  );
}
